import { render, staticRenderFns } from "./ImportStock.vue?vue&type=template&id=4528132a&"
import script from "./ImportStock.vue?vue&type=script&lang=js&"
export * from "./ImportStock.vue?vue&type=script&lang=js&"
import style0 from "./ImportStock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports